var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9648 4.75C8.96078 4.75 5.71484 7.99594 5.71484 12C5.71484 16.0041 8.96078 19.25 12.9648 19.25C16.9689 19.25 20.2148 16.0041 20.2148 12C20.2148 7.99594 16.9689 4.75 12.9648 4.75ZM4.21484 12C4.21484 7.16751 8.13235 3.25 12.9648 3.25C17.7973 3.25 21.7148 7.16751 21.7148 12C21.7148 16.8325 17.7973 20.75 12.9648 20.75C8.13235 20.75 4.21484 16.8325 4.21484 12Z",
    fill: "#00385F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8146 9.30875C10.8811 10.0768 10.2574 11.1571 10.059 12.3496L9.62108 14.9824C9.39366 16.3496 10.9834 17.2675 12.0537 16.3869L14.1149 14.6912C15.0484 13.9232 15.6721 12.8429 15.8705 11.6504L16.3084 9.01756C16.5358 7.65035 14.9461 6.73251 13.8758 7.61307L11.8146 9.30875ZM12.9648 10.5C12.1364 10.5 11.4648 11.1716 11.4648 12C11.4648 12.8284 12.1364 13.5 12.9648 13.5C13.7933 13.5 14.4648 12.8284 14.4648 12C14.4648 11.1716 13.7933 10.5 12.9648 10.5Z",
    fill: "#00385F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.d1fa709b046cbfe296a6adec1fafad8f.svg";
export { ForwardRef as ReactComponent };